<mat-error @error *ngIf="control.invalid && (control.dirty || control.touched) && errorKey">
  <!-- display first error -->
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^(?=.*[a-zA-Z])([a-zA-Z0-9 ]+)$/'">
    {{'ERRORS.pattern' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^([A-Za-z])([a-zA-Z0-9_])+( [a-zA-Z0-9_]+)*$/'">
    {{'ERRORS.pattern' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '/^[a-zA-Z]+$/'">
    {{'ERRORS.patternAlphabet' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey === 'pattern' && control.errors?.pattern?.requiredPattern === '^([A-Za-z0-9]{9}|[A-Za-z0-9]{12})$'">
    {{'ERRORS.patternCount' | transloco: errorParams}}
  </span>
  <span *ngIf="errorKey !== 'pattern'">
    {{'ERRORS.' + errorKey | transloco: errorParams}}
  </span>
</mat-error>
